import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { useLocalStorageStore } from '@mono-farmart-web/state-management';
import { langCodeToIdMap } from './constants';
import { i18n } from './i18n';

interface InitI18nProps {
	langId?: string;
}

const languageUrl: Record<string, string> = {
	EN: '/locales/en.json',
	HI: '/locales/hi.json',
	MR: '/locales/mr.json',
};

export function initI18n(props?: InitI18nProps) {
	const { userLanguage } = useLocalStorageStore.getState();
	const langId = userLanguage?.langId || props?.langId || '2';
	const langCode = langCodeToIdMap[langId];

	const i18nInitialized = i18n
		.use(HttpBackend)
		.use(initReactI18next)
		.init({
			lng: langCode,
			fallbackLng: 'EN',
			supportedLngs: ['EN', 'HI', 'MR'],
			backend: {
				loadPath: (lngs: string[]) => languageUrl[lngs[0]] ?? languageUrl.EN,
			},
			interpolation: {
				escapeValue: false, // React already escapes
			},
		});

	syncLanguage({ langId, langCode: langCode });

	return i18nInitialized;
}

interface SyncLanguageProps {
	langCode: string;
	langId: string;
}

export function syncLanguage(selectedLanguage?: SyncLanguageProps) {
	const { userLanguage, setUserLanguage } = useLocalStorageStore.getState();

	if (selectedLanguage?.langId) {
		setUserLanguage(selectedLanguage);
	}

	const lang = selectedLanguage || userLanguage;
	if (lang?.langCode) {
		i18n.changeLanguage(lang.langCode);
	}
}

export default i18n;

export { default as Trans } from './components/Trans';

export { I18nextProvider } from 'react-i18next';
export { LanguageProvider, useLanguage } from './context/language';
export { setLanguageData, getLanguageData } from './service/languageService';
export { default as useI18n } from './hooks/usei18n';
export * from './Keys';
